import React from "react"
import {
  NavHeader,
  Container,
  Logo,
  NavBtn,
  Label,
  Span,
  NavLinks,
  NavLink,
  NavExternalLink,
  NavCheck
} from "./elements"
import logo from "../../img/muv-logo.svg"
import { useTranslation } from "react-i18next"
import { Box } from "../Flex"

export const HeaderContext = React.createContext({ open: false })

const menu = [
  { slug: "/driver", name: "driver" },
  { slug: "/corporate", name: "corporate" },
  { slug: "/help-center", name: "help" }
]
const rightMenu = [
  { slug: "/", name: "signUp", external: false },
  { slug: "/", name: "logIn", external: false }
]

const Header = ({ secondary }) => {
  const [open, setOpen] = React.useState(false)
  const { t } = useTranslation()

  return (
    <HeaderContext.Provider value={{ open }}>
      <Container secondary={secondary}>
        <NavHeader>
          <Logo src={logo} to="/" />
        </NavHeader>
        <NavBtn onClick={() => setOpen(!open)}>
          <Label htmlFor={NavCheck}>
            <Span />
            <Span />
            <Span />
          </Label>
        </NavBtn>

        <NavLinks open={open}>
          <Box>
            {menu.map(({ name, slug }) => (
              <NavLink key={name} to={slug}>
                {t(name)}
              </NavLink>
            ))}
          </Box>
          <Box order={[-1, 1]}>
            {rightMenu.map(({ name, slug, external }) => (
              <>
              {external &&
                <NavExternalLink key={name} href={slug} target="_blank">
                {t(name)}
              </NavExternalLink>
              }
              {!external &&
                <NavLink key={name} to={slug}>
                {t(name)}
              </NavLink>
              }
              </>              
            ))}
          </Box>
        </NavLinks>
      </Container>
    </HeaderContext.Provider>
  )
}

export default Header
